<template>
  <div class="carousel" v-if="mq.mdPlus">
    <Transition name="fade">
      <div v-if="shown" class="carousel__images">
        <Image :source="images[currentImg].left_image" class="carousel__image" />
        <Image
          v-if="images[currentImg].right_image"
          :source="images[currentImg].right_image"
          class="carousel__image"
        />
      </div>
    </Transition>
    <div class="carousel__buttons">
      <button class="button -square carousel__left" @click="changeImage(false)">
        <Icon id="arrow" />
      </button>
      <button class="button -square" @click="changeImage">
        <Icon id="arrow" />
      </button>
    </div>
  </div>
  <Swiper
    v-else
    class="carousel__mobile"
    :modules="modules"
    :free-mode="true"
    slides-per-view="auto"
    :space-between="30"
  >
    <template v-for="(block, index) in images" :key="index">
      <SwiperSlide class="carousel__mobile-slide" :class="{ '-larger': !block.right_image }">
        <Image :source="block.left_image" />
      </SwiperSlide>
      <SwiperSlide v-if="block.right_image" class="carousel__mobile-slide">
        <Image :source="block.right_image" />
      </SwiperSlide>
    </template>
  </Swiper>
</template>

<script>
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'

export default {
  name: 'ImgCarousel',
  inject: ['mq'],
  components: {
    Icon,
    Image,
    Swiper,
    SwiperSlide,
  },
  props: {
    images: Array,
  },
  data() {
    return {
      currentImg: 0,
      shown: true,
      modules: [FreeMode],
    }
  },
  methods: {
    changeImage(navigateRight = true) {
      this.shown = false

      window.setTimeout(() => {
        this.currentImg = navigateRight
          ? this.currentImg >= this.images.length - 1
            ? 0
            : this.currentImg + 1
          : (this.currentImg <= 0 ? this.images.length : this.currentImg) - 1

        this.shown = true
      }, 200)
    },
  },
}
</script>
